<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow">
            <div class="card-body">
              <h1>{{ $t("message.menu.contacts") }}</h1>
              <b-tabs pills content-class="mt-3" small>
                <b-tab
                  v-for="(address, ind) in addresses_"
                  :title="address.country"
                  lazy
                  @click="loadMap(ind)"
                  :key="ind"
                >
                  <h4><i class="fa fa-map-pin"></i> {{ address.address }}</h4>
                  <div
                    :id="'map' + ind"
                    style="height: 400px; border-radius: 6px"
                  ></div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    addresses_() {
      return this.addresses[this.$i18n.locale];
    },
  },
  mounted() {
    setTimeout(() => {
      this.loadMap(0);
    }, 1000);
  },
  methods: {
    loadMap(index) {
      // console.log(index)
      setTimeout(() => {
        var myMap = new ymaps.Map("map" + index, {
          center: [32.2044468, 118.7034777],
          zoom: 9,
        });
        var this_ = this;
        ymaps
          .geocode(
            this.addresses.ru[index].country +
              ", " +
              this.addresses.ru[index].address,
            {
              /**
               * Опции запроса
               * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/geocode.xml
               */
              // Сортировка результатов от центра окна карты.
              // boundedBy: myMap.getBounds(),
              // strictBounds: true,
              // Вместе с опцией boundedBy будет искать строго внутри области, указанной в boundedBy.
              // Если нужен только один результат, экономим трафик пользователей.
              results: 1,
            },
          )
          .then(function (res) {
            // Выбираем первый результат геокодирования.
            var firstGeoObject = res.geoObjects.get(0);
            // console.log(firstGeoObject, myMap)
            if (typeof firstGeoObject !== "undefined") {
              // Координаты геообъекта.
              var coords = firstGeoObject.geometry.getCoordinates(),
                // Область видимости геообъекта.
                bounds = firstGeoObject.properties.get("boundedBy");
              firstGeoObject.options.set(
                "preset",
                "islands#darkBlueDotIconWithCaption",
              );
              // Получаем строку с адресом и выводим в иконке геообъекта.
              firstGeoObject.properties.set(
                "iconCaption",
                firstGeoObject.getAddressLine(),
              );

              // Добавляем первый найденный геообъект на карту.
              myMap.geoObjects.add(firstGeoObject);
              // Масштабируем карту на область видимости геообъекта.
              myMap.setBounds(bounds, {
                // Проверяем наличие тайлов на данном масштабе.
                checkZoomRange: true,
              });
            } else {
              // console.log('a')
              var coords = this_.addresses.ru[index].geo;
              //      	myMap = new ymaps.Map('map'+index, {
              //     center: coords,
              //     zoom: 9
              // });
              var obj = new ymaps.GeoObject({
                geometry: {
                  type: "Point", // тип геометрии - точка
                  coordinates: coords, // координаты точки
                },
              });
              myMap.geoObjects.add(obj);
              myMap.setCenter(coords);
              // myMap.setBounds(myMap.geoObjects.getBounds())
            }

            /**
             * Все данные в виде javascript-объекта.
             */
            // console.log('Все данные геообъекта: ', firstGeoObject.properties.getAll());
            /**
             * Метаданные запроса и ответа геокодера.
             * @see https://api.yandex.ru/maps/doc/geocoder/desc/reference/GeocoderResponseMetaData.xml
             */
            // console.log('Метаданные ответа геокодера: ', res.metaData);
            /**
             * Метаданные геокодера, возвращаемые для найденного объекта.
             * @see https://api.yandex.ru/maps/doc/geocoder/desc/reference/GeocoderMetaData.xml
             */
            // console.log('Метаданные геокодера: ', firstGeoObject.properties.get('metaDataProperty.GeocoderMetaData'));
            /**
             * Точность ответа (precision) возвращается только для домов.
             * @see https://api.yandex.ru/maps/doc/geocoder/desc/reference/precision.xml
             */
            // console.log('precision', firstGeoObject.properties.get('metaDataProperty.GeocoderMetaData.precision'));
            /**
             * Тип найденного объекта (kind).
             * @see https://api.yandex.ru/maps/doc/geocoder/desc/reference/kind.xml
             */
            // console.log('Тип геообъекта: %s', firstGeoObject.properties.get('metaDataProperty.GeocoderMetaData.kind'));
            // console.log('Название объекта: %s', firstGeoObject.properties.get('name'));
            // console.log('Описание объекта: %s', firstGeoObject.properties.get('description'));
            // console.log('Полное описание объекта: %s', firstGeoObject.properties.get('text'));
            /**
             * Прямые методы для работы с результатами геокодирования.
             * @see https://tech.yandex.ru/maps/doc/jsapi/2.1/ref/reference/GeocodeResult-docpage/#getAddressLine
             */
            // console.log('\nГосударство: %s', firstGeoObject.getCountry());
            // console.log('Населенный пункт: %s', firstGeoObject.getLocalities().join(', '));
            // console.log('Адрес объекта: %s', firstGeoObject.getAddressLine());
            // console.log('Наименование здания: %s', firstGeoObject.getPremise() || '-');
            // console.log('Номер здания: %s', firstGeoObject.getPremiseNumber() || '-');

            /**
             * Если нужно добавить по найденным геокодером координатам метку со своими стилями и контентом балуна, создаем новую метку по координатам найденной и добавляем ее на карту вместо найденной.
             */
            /**
			             var myPlacemark = new ymaps.Placemark(coords, {
			             iconContent: 'моя метка',
			             balloonContent: 'Содержимое балуна <strong>моей метки</strong>'
			             }, {
			             preset: 'islands#violetStretchyIcon'
			             });

			             myMap.geoObjects.add(myPlacemark);
			             */
          });
      }, 1000);
    },
  },
  data() {
    return {
      addresses: {
        ru: [
          {
            country: "Китай",
            address:
              "Провинция Джансу, город Нанькин, Джанбей Нью Ареа, Хингху роад, 15, офис 208",
            geo: [32.2044468, 118.7034777],
          },
          {
            country: "Казахстан",
            address: "город Нур-Султан, улица Кунаева, 4.",
          },
          {
            country: "Россия",
            address:
              "город Москва, улица Пресненский вал, дом 27, строение 24, Помещение № IV, комната № 2",
          },
          {
            country: "Ирландия",
            address:
              "город Грейстоунс, A63WK40, улица Хилл Сайд роуд , Зое Хауз",
            geo: [53.1450769, -6.066246],
          },
          {
            country: "Латвия",
            address:
              "LV-1010, город Рига, Центральный район, улица К. Вальдемара, дом 19",
          },
        ],
        en: [
          {
            country: "China",
            address:
              "Room 208, #15, Xinghuo Road, Jiangbei New Area, Nanjing, Jiangsu",
          },
          {
            country: "Kazakhstan",
            address: "4, Kunaeva street, Nur-Sultan.",
          },
          {
            country: "Russia",
            address:
              "office 2, room IV, block 24, building 27, Presnensky val street, Moscow",
          },
          {
            country: "Ireland",
            address: "Zoe House, Hillside Road, A63WK40, Greystones",
            geo: [53.1450769, -6.066246],
          },
          {
            country: "Latvia",
            address: "19, K.Valdemara street, Central district, Riga, LV-1010",
          },
        ],
        cn: [
          {
            country: "中国",
            address: "南京市江北新区星火路15号创芯孵化器2楼208室",
          },
          {
            country: "哈萨克斯坦",
            address: "哈萨克斯坦努尔苏丹库纳耶娃街4号",
          },
          {
            country: "俄国",
            address: "俄罗斯莫斯科普伦涅斯基大街2​​7号楼24座IV室2号办公室",
          },
          {
            country: "Ireland",
            address: "Zoe House, Hillside Road, A63WK40, Greystones",
            geo: [53.1450769, -6.066246],
          },
          {
            country: "Latvia",
            address: "19, K.Valdemara street, Central district, Riga, LV-1010",
          },
        ],
      },
    };
  },
};
</script>
